const IconInput = ({
    ref,
    icon,
    value,
    onChange,
    placeholder,
    name,
    id,
    height = "50px",
}) => {
    return (
        <div
            className="
                tw:flex tw:items-center
                tw:border tw:border-[#DADADA]
                tw:focus-within:border-[#DBBE78]
                tw:focus-within:shadow-[0_0_0_3px_rgba(219,190,120,0.18)]
                tw:rounded-md
                tw:px-3
                tw:transition-[border-color,box-shadow] tw:duration-200
            "
            style={{ height }}
        >
            {icon && (
                <span className="tw:mr-2 tw:flex-shrink-0">
                    {icon}
                </span>
            )}

            <input
                ref={ref}
                type="text"
                autoComplete="off"
                name={name}
                id={id}
                placeholder={placeholder}
                value={value ?? ""}
                onChange={onChange}
                className="
                    tw:w-full
                    tw:outline-none
                    tw:text-[15px]
                    tw:font-[400]
                    tw:text-[#4E4E4E]
                    tw:font-[var(--font-sans-primary)]
                    tw:placeholder:!text-[#A7A7A7]
                    tw:placeholder:!font-[var(--font-sans-primary)]
                    tw:placeholder:!text-[15px]
                    tw:placeholder:!font-[400]
                "
            />
        </div>
    );
};

export default IconInput;
